module.exports = __webpack_public_path__ + "static/support-1765cbf49588eae0c0e9d869085da1cd.png";